<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">Afiliación</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="continuarNavegacion()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>

    <div class="row content confirmafiliacion">
        <div class="ico">
            <mat-icon aria-hidden="false" aria-label="Example home icon">check</mat-icon>
        </div>
        <h4 class="confirmafiliaciontitulo">Confirmado</h4>

        <p><strong>!En hora buena!</strong></p>
        <p><strong>{{usuarioCreado.nombres}} {{usuarioCreado.apellidos}} /  {{usuarioCreado.nroDocumento}}</strong></p>

        <p>Ahora eres afiliado al servicio de {{descripcionProducto}} y puedes empezar a disfrutar de sus beneficios a partir de este momento.<br><br> Para mayor información, términos, condiciones y/o cobertura, visita<br><br>
            <a [href]="this.urlAliado" target="_blank">{{this.urlAliado}}</a><br><br> Para solicitar asistencia comunícate al<br><br>
            <b>Nacional</b> {{this.lineaNacionalAliado}} (gratis cobro revertido)<br>
            <b>Medellín</b> {{this.nroFijoAliado}}
        </p>
        <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
        <div class="mensajeconfirmacion" *ngIf="mensajesEnviados">
            <h1>¡Mensaje de confirmación enviado!</h1>
            <p>{{this.MensajeConfirmacionTipoNotificacion()}}</p>
        </div>
    </div>
</div>